<!--  -->
<template>
  <div class='flow'>
    <div class="flow__point" :class="{'flow__point--active': activePoint, 'flow__point--first': isFirst}">
      <div v-if="activePoint" class="flow__point--active-child"></div>
    </div>
    <div v-if="!onlyOne" class="flow__line" :class="{'flow__line--first': isFirst, 'flow__line--last': isLast}"></div>
  </div>
</template>

<script>
export default {
  props: {
    activePoint: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    onlyOne: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang='less' scoped>
@w2: 75rem;
.flow {
  width: 18 / @w2;
  position: absolute;
  overflow: hidden;
  height: 100%;
  &__point {
    position: absolute;
    left: 0;
    right: 0;
    top: 38 / @w2;
    width: 12 / @w2;
    height: 12 / @w2;
    background-color: #ebebeb;
    border-radius: 6 / @w2;
    z-index: 6;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__point--first {
    top: 38 / @w2;
  }
  &__line {
    width: 2 / @w2;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 0 auto;
    background-color: #ebebeb;
  }
  &__point--active {
    width: 18 / @w2;
    height: 18 / @w2;
    background-color: #d0e7ff;
    border-radius: 9 / @w2;
    &-child {
      background-color: #409eff;
      width: 12 / @w2;
      height: 12 / @w2;
      border-radius: 6 / @w2;
    }
  }
  &__line--first {
    top: 40 / @w2;
  }
  &__line--last {
    height: 40 / @w2;
  }
}
</style>
